import { getApiBaseUrl } from '../utils/apiBaseUrl'

export const markFeedbackAsRead = async (
    id: number,
    isFlagged: boolean,
    token: string
  ): Promise<void> => {
    const baseUrl = getApiBaseUrl();
    const response = await fetch(
      `${baseUrl}/api/Feedback/MarkFeedbackAsReadAsync?id=${id}`,
      {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ isFlagged })
      }
    );
  
    if (!response.ok) {
      throw new Error(`Failed to mark feedback as read: ${response.status}`);
    }
  };
  